function toEnum(value, type) {
  for (let k of Object.keys(type))
    if (type[k] == value) return k
  return null
}

// Creates the enum as a function with the keys as static properties.
// When called with the value, the function will return the enum associated with that value.
export const createEnum = values => {
  const type = v => toEnum(v, type)
  for (let k of Object.keys(values))
    type[k] = values[k]
  return type
}

const DeviceStates = [
  'alarming',
  'armed',
  'communicating',
  'disarmed',
  'healthy',
  'locked',
  'open',
  'silentAlarming',
  'unassigned',
  'unhealthy',
  'unknown',
  'unlocked',
]

// a simple enum for position states
export const DeviceState = DeviceStates.reduce((obj, s) => { obj[s] = s; return obj }, { })

export const DeviceType = createEnum({
  alarmModule: 'alarm_module',
  base: 'base',
  cxFlex: 'core_iii', // deprecated
  cxFlex1: 'core_iii_one_port',
  cxFlex4: 'core_iii_four_port',
  dumbPuck: 'dumb_puck',
  fm2Base: 'base_v2',
  fm2Puck: 'puck_v2',
  lock: 'lock',
  nxdiBase: 'di_riser',
  nxdiPuck: 'di_puck',
  powerFlex: 'powerflex',
  proximityBase: 'proximity_base',
  proximityPuck: 'proximity_puck',
  puck: 'puck',
  ram: 'ram',
  repeater: 'repeater',
  securePlug: 'secure_plug',
})

// Roles are the different possible user role keys
export const Role = createEnum({
  // app provider roles
  superUser: 'super_user',
  tierOneSupport: 'tier_one_support',
  fieldTechnician: 'field_technician',
  mtiTechnician: 'mti_tech',

  // client user roles
  keyUser: 'key_user',
  organizationAdministrator: 'organization_administrator',
  regionalManager: 'regional_manager',
  storeAssociate: 'store_associate',
  storeManager: 'store_manager',
  storeTechnician: 'store_technician',
  supportAnalyst: 'support_analyst',
  thirdPartyAssociate: 'third_party_associate',
  userAdministrator: 'user_administrator',
})

export const KeyType = createEnum({
  ble: 'BLE',
  ephemeral: 'EPHEMERAL',
  rfid: 'VERSA',
})

export const OpenBeforeAlarmDuration = createEnum({
  noAlarm: 0xF,
  thirtySec: 0x3,
  ninetySec: 0x4,
  threeMin: 0x5,
  fiveMin: 0x0,
  fifteenMin: 0x1,
  thirtyMin: 0x2,
})

export const OpenAlarmDuration = createEnum({
  thirtySec: 0x3,
  oneMin: 0x2,
  threeMin: 0x1,
  fiveMin: 0x0,
})
